import { render } from "./CheckCoverage.vue?vue&type=template&id=5911d390"
import script from "./CheckCoverage.vue?vue&type=script&lang=js"
export * from "./CheckCoverage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__